<template>
  <div>
    <section-page
      title="Up Next"
      description="Keep track of your past due and upcoming tasks, along with your upcoming appointments."
      full-height
    >
      <template v-slot:right>
        <table-buttons
          show-filters-button
          :do-filters-apply="applyFilters"
          :do-filters-reset="resetFilters"
        >
          <template v-slot:filters>
            <up-next-filter ref="filters"/>
          </template>
        </table-buttons>
      </template>

      <b-tabs v-model="currentTab" class="mt-100">
        <b-tab-item label="Calendar" value="calendar" class="mt-100">
          <up-next-calendar-desktop ref="calendar" @setDates="loadEvents"/>
        </b-tab-item>

        <b-tab-item label="List" value="list" class="mt-100">
          <up-next-list-desktop
            :calendar-api="calendarApi"
            @control="handleListingControls"
          />
        </b-tab-item>
      </b-tabs>

      <app-loading-section :loading="isLoading"/>
    </section-page>
  </div>
</template>

<script>
import UpNextCalendarDesktop from "./UpNextCalendarDesktop.vue";
import UpNextListDesktop from "./UpNextListDesktop.vue";
import UpNextFilter from "./components/UpNextFilter.vue";
import TableButtons from "../../components/table/TableButtons.vue";

export default {
  name: "UpNextPageDesktop",
  components: {
    TableButtons,
    UpNextFilter,
    UpNextListDesktop,
    UpNextCalendarDesktop,
  },
  data() {
    return {
      isLoading: true,
      currentTab: 'calendar',
      calendarApi: null,
    }
  },
  created() {
    this.$store.dispatch("upNext/setup").then(() => {});
    this.currentTab = this.$store.getters["upNext/pageView"];
  },
  destroyed() {
    this.$store.dispatch("upNext/teardown");
  },
  watch: {
    currentTab(newValue) {
      if (newValue === 'calendar') {
        this.$nextTick(() => {
          if (this.calendarApi !== null) {
            // recalculates dimensions after being hidden from switching tabs
            this.calendarApi.updateSize();
          }
        });
      }
    }
  },
  methods: {
    handleListingControls(event) {
      this.$refs.calendar.handleControls(event);
    },
    resetFilters() {
      this.$refs.filters.resetFilters();
    },
    applyFilters() {
      this.$refs.filters.applyFilters();
      this.currentTab = this.$store.getters["upNext/pageView"];
      this.loadEvents(this.$refs.calendar.getDates());
    },
    loadEvents(data) {
      this.isLoading = true;
      this.$store.dispatch('upNext/fetchEvents', data)
        .then(response => {
          this.calendarApi = this.$refs.calendar.calendarApi();
        })
        .finally(() => this.isLoading = false);
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
